import React from 'react';
import './AboutContents.scss';

const AboutContents1 = () => {
  return (
    <div className="mq">
      <div className="aboutContents">
        <img
          className="productLogoImage"
          src="/images/v1_8.png"
          alt="heatsink"
        />
        <div className="aboutContentsLeft">
          <div className="aboutContentsLeftTitle">
            항공기 엔진 연구진이 직접 설계한 무동력팬
          </div>
          <img
            className="productImage"
            // src="/images/v4_55.png"
            src="/images/Image1-3.jpg"
            alt="product"
          />
          <div className="aboutContentsLeftInfo">
            <p>오리지널 TEF의 제작사 Aspen Tech가</p>
            <p>열역학 설계 프로그램 제작사라는 사실을 아시나요?</p>
            <p>무동력 팬은 단순한 캠핑 장비가 아닙니다.</p>
            <p> 열전달과 유체역학에 대한 </p>
            <p>명확한 지식과 이해를 바탕으로 설계되어야</p>
            <p>완전한 성능을 가진 무동력 팬을 만들 수 있습니다.</p>
            <br />
            <br />
            <p>서울대학교 Turbomachinery Lab 출신의 </p>
            <p>가스터빈 엔진 연구진이</p>
            <p>항공기 엔진 연구개발 기술을 활용하여</p>
            <p>현존하는 최고의 무동력 팬을 만들었습니다.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutContents1;
